
export default function Footer() {
  const serviceAreas = [
    "Escondido", "San Marcos", "Vista", "Carlsbad", "Encinitas", 
    "Solana Beach", "Del Mar", "Poway", "Rancho Bernardo", "Carmel Valley", 
    "La Jolla", "Pacific Beach", "San Diego", "Chula Vista", "Oceanside",
    "El Cajon", "National City", "La Mesa", "Santee", "Lemon Grove",
    "Spring Valley", "Bonita", "Imperial Beach", "Coronado", "Mission Beach",
    "Ocean Beach", "Point Loma", "Hillcrest", "University City", "Mira Mesa",
    "Scripps Ranch", "Tierrasanta", "Serra Mesa", "Clairemont", "Bay Park",
    "Mission Valley", "Fashion Valley", "Kearny Mesa", "Linda Vista", "Allied Gardens",
    "San Carlos", "Del Cerro", "Grantville", "Mission Gorge", "Navajo",
    "College Area", "Rolando", "Talmadge", "Kensington", "Normal Heights",
    "North Park", "South Park", "Golden Hill", "Banker's Hill", "Little Italy",
    "Downtown San Diego", "Gaslamp Quarter", "East Village", "Marina District", "Midway",
    "Sports Arena", "Roseville", "Morena", "Bay Ho", "Pacific Highlands Ranch",
    "Torrey Pines", "Torrey Hills", "Carmel Creek", "Fairbanks Ranch", "Rancho Santa Fe",
    "4S Ranch", "Bernardo Heights", "Sabre Springs", "Rancho Penasquitos", "Black Mountain Ranch",
    "Miramar", "Sorrento Valley", "Sorrento Mesa", "Torrey Pines Mesa", "Eastlake",
    "Otay Ranch", "Millenia", "Rolling Hills Ranch", "Rancho San Diego", "Jamul",
    "Dulzura", "Campo", "Descanso", "Pine Valley", "Guatay",
    "Mount Laguna", "Julian", "Santa Ysabel", "Ramona", "San Pasqual",
    "Valley Center", "Pauma Valley", "Rincon", "Fallbrook", "Bonsall",
    "Rainbow", "Camp Pendleton South", "Hidden Meadows", "Deer Springs", "Harmony Grove",
    "Elfin Forest", "San Dieguito", "Olivenhain", "Cardiff", "Leucadia",
    "Temecula"
  ];

  const services = [
    "Carpet Cleaning", "Furniture Cleaning", "Mattress Cleaning", 
    "Area Rug Cleaning", "Odor Removal", "Commercial Cleaning",
    "Carpet Cleaning in apartments/condos", "Office Cubicle Cleaning",
    "Steam Cleaning for Non-Profit Organizations", "Vehicle Interior Cleaning"
  ];

  const socialLinks = [
    { icon: "fab fa-facebook", url: "https://www.facebook.com/blueteamhomeservices/", label: "Facebook" },
    { icon: "fab fa-twitter", url: "https://twitter.com/blueteamhome", label: "Twitter" },
    { icon: "fab fa-youtube", url: "https://www.youtube.com/channel/UCtgUB5Tq0_xf0BjfnMu7Utw/videos", label: "YouTube" },
    { icon: "fab fa-instagram", url: "https://www.instagram.com/blueteamhomeservices/", label: "Instagram" },
    { icon: "fab fa-linkedin", url: "https://www.linkedin.com/company/blue-team-home-services", label: "LinkedIn" }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/6473f32a47a131b496242da22ce546c9/6b23656feb7c8e7c7f58fff4bf1c9ee9.jpeg" 
              alt="Blue Team Home Services Logo" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Blue Team Home Services is a family-owned and operated carpet cleaning company in Escondido. We use only the best safe cleaning products, and guarantee 100% customer satisfaction. Your home or office will always stay clean and safe!
            </p>
            <p className="text-gray-300 mb-6">
              Contact us for any <strong>carpet cleaning</strong> or <strong>furniture & upholstery cleaning</strong> needs and our staff will work with you in an individual manner.
            </p>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Service Areas</h4>
            <ul className="space-y-2">
              {serviceAreas.map((area) => (
                <li key={area}>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                    {area}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Services</h4>
            <ul className="space-y-2">
              {services.slice(0, 10).map((service) => (
                <li key={service}>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact us</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="fa fa-map-marker-alt text-teal-400 mt-1 mr-3"></i>
                <a 
                  href="https://goo.gl/maps/WsbScAedniN5HXUA8" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Escondido, CA 92025
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="fa fa-phone text-teal-400 mr-3"></i>
                <a 
                  href="tel:+16197482446" 
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  (619) 748-2446
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="fa fa-envelope text-teal-400 mr-3"></i>
                <a 
                  href="mailto:blueteamcarpet@gmail.com" 
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  blueteamcarpet@gmail.com
                </a>
              </div>
            </div>

            <div className="mt-8">
              <h5 className="text-lg font-semibold mb-4">Get Social</h5>
              <div className="flex space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © Copyright 2025 | <a href="#" className="hover:text-white cursor-pointer">Blue Team Home Services</a> | 
              <a href="#" className="hover:text-white cursor-pointer ml-1">Carpet Cleaning Escondido</a> | 
              <a href="#" className="hover:text-white cursor-pointer ml-1">Furniture & Upholstery Cleaning Escondido</a> | 
              built by <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Blue Team Carpet & Dryer Vent Cleaning. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
